import React, { useState } from 'react'
import { DraggableIcon, MapPinIcon, MapDeviceRemove, SearchIcon, SearchIconWhite } from '../../../../assets/images'
import Draggable from 'react-draggable';
import { hasDecimalPoint, removeDecimalAndGetAbsolute } from '../../../../utils/utils';

const CustomImageMap = ({ isDarkTheme, deviceList, setDeviceList, selectedImage, editForm, deviceMasterList, setDeviceMasterList, droppedItems, setDroppedItems }) => {
    
    const [searchTextDevice, setSearchTextDevice] = useState("")

    //#region Custom Image Marker Functions

    const handleDragStart = (event, icon) => {
        if(!editForm || selectedImage == null){
            return;
        }
        if(droppedItems.find(item => item.DeviceId === icon.DeviceId)){
            return;
        }
        event.dataTransfer.setData('icon', JSON.stringify(icon));
    };

    console.log("deviceListdeviceList", deviceList);

    const searchHandler = (text) => {
        setSearchTextDevice(text);
        let temp = deviceMasterList.filter((item) => item.Name.toLowerCase().includes(text.toLowerCase()))
        setDeviceList(temp);
    }

    const handleDrop = (event) => {
        if(!editForm || selectedImage == null){
            return;
        }
        event.preventDefault();
        const icon = JSON.parse(event.dataTransfer.getData('icon'));
        const rect = event.target.getBoundingClientRect();
        let x = event.clientX - rect.left;
        let y = event.clientY - rect.top;
        x = removeDecimalAndGetAbsolute(x)
        y = removeDecimalAndGetAbsolute(y)
        console.log("PositionItems", x, y)
        setDroppedItems([...droppedItems, { ...icon, position: { x, y } }]);
        let tempArr = deviceMasterList.map((item) => {
            if (item.DeviceId == icon.DeviceId) {
                return {
                    ...item,
                    isSelected: true,
                    isTouched: true,
                    Lat: x,
                    Long: y
                }
            } else {
                return {
                    ...item
                }
            }
        })
        setDeviceList(tempArr)
        setDeviceMasterList(tempArr)
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleDrag = (index, e, data, indivData) => {
        console.log("CustomMapDrag", indivData)
        if(!editForm || selectedImage == null){
            return;
        }
        const updatedItems = [...droppedItems];
        updatedItems[index].position = { x: removeDecimalAndGetAbsolute(data.x), y: removeDecimalAndGetAbsolute(data.y) };
        setDroppedItems(updatedItems);
        let tempArr = deviceMasterList.map((item) => {
            if (item.DeviceId == indivData.DeviceId) {
                return {
                    ...item,
                    isSelected: true,
                    isTouched: true,
                    Lat: removeDecimalAndGetAbsolute(data.x),
                    Long: removeDecimalAndGetAbsolute(data.y)
                }
            } else {
                return {
                    ...item
                }
            }
        })
        setDeviceList(tempArr)
        setDeviceMasterList(tempArr)

    };

    const removeMarker = (DeviceId) => {
        if(!editForm || selectedImage == null){
            return;
        }
        let tempArr = deviceMasterList.map((item) => {
            if (item.DeviceId == DeviceId) {
                return {
                    ...item,
                    isSelected: false,
                    isTouched: true,
                    Lat: 0.0,
                    Long: 0.0
                }
            } else {
                return {
                    ...item
                }
            }
        })
        setDeviceList(tempArr)
        setDeviceMasterList(tempArr)
        let secondTempArr = droppedItems.filter((item) => item.DeviceId != DeviceId)
        setDroppedItems(secondTempArr)
    }

    //#endregion


    return (
        <div className='mt-4 MapContainerFlex'>
            <div className='Map_List'>
                <div className="m-2 HeaderSiteList">
                    <input
                        id="Search_txt_site"
                        className="SearchViewInput1" style={{ width: "80%" }}
                        type="text"
                        value={searchTextDevice}
                        onChange={(e) => searchHandler(e.target.value)}
                        placeholder="Search" />
                    <div className="SearchTextDivConfigTool">
                        {
                            isDarkTheme ?
                                <img
                                    className="EyeIcon"
                                    src={SearchIcon}
                                    alt="search icon"
                                /> :
                                <img
                                    className="EyeIcon"
                                    src={SearchIconWhite}
                                    alt="search icon" height="15"
                                />
                        }
                    </div>
                </div>
                <div className="StepperSiteList" style={{ height: "40vh" }} >
                    {
                        deviceList.filter(i => (i.Lat == null || i.Lat == 0 || !hasDecimalPoint(i.Lat))).map((item) => (
                            <div className='MapListText' key={item.DeviceId} 
                                draggable={!editForm && selectedImage != null}
                                onDragStart={(e) => handleDragStart(e, item)}
                                // style={{ cursor: 'grab' }}
                                style={{ cursor: (editForm && selectedImage != null) ? 'grab' : 'not-allowed' }}
                                >
                                <div className='DeviceNamesDiv'>
                                    <img className="EyeIcon" src={DraggableIcon} style={{cursor : (!editForm || selectedImage == null) && 'not-allowed'}} alt="search icon" />
                                    <p className="ListofText">
                                        {item.Name}
                                    </p>
                                </div>
                                {
                                    item.isSelected
                                        ? <img className="EyeIcon" src={MapDeviceRemove} style={{cursor : (!editForm || selectedImage == null) && 'not-allowed'}} alt="search icon" onClick={() => removeMarker(item.DeviceId)} />
                                        : null
                                }
                            </div>
                        ))
                    }
                </div>
            </div>
            <div className='Map_Preview'>
                {/* <p  className='Map_Preview_text'>Custom Map Preview</p> */}
                <div className="Image_Container"
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    style={{
                        // border: '1px solid black',
                        margin: '0.5rem',
                        // height: '95%', 
                        height: '424px',
                        width: '875px',
                        // width:'100%',
                        position: 'relative', overflow: 'hidden'
                    }}>
                    {
                        selectedImage
                        ?
                        <img
                        src={selectedImage}
                        alt="Drop zone"
                        style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }}
                        />
                        : 
                        <p className='CenterTextFont m-0' style={{color:"#6c6c6c"}}>
                            Please browse an image from your device, and it will be previewed here.
                        </p>
                    }

                    
                    {droppedItems.map((item, index) => (
                        <Draggable
                            disabled={!editForm && selectedImage == null}
                            key={item.DeviceId}
                            position={item.position}
                            // onStop={(e, data) => handleDrag(index, e, data, item)}
                            onDrag={(e, data) => handleDrag(index, e, data, item)}
                            bounds="parent"
                        >

                            <div
                                style={{
                                    position: 'absolute',
                                    fontSize: '5px',
                                    cursor: (editForm && selectedImage != null) ? 'move' : 'not-allowed',
                                    width: '40px',
                                    height: '40px',
                                    backgroundImage: `url(${MapPinIcon})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center'
                                }}
                                title={item.Name}
                            > 
                            </div> 
                        </Draggable>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default CustomImageMap